import { StyleSheet } from 'react-native';
import { brand, neutrals } from '../../../theme/colors';

export const styles = StyleSheet.create({
  workingAreaOverlayContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 10,
  },
  selectionContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    borderRadius: 100,
    borderColor: 'transparent',
  },
  selectionContainerInner: {
    height: '100%',
    width: '100%',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  selectionContainerBackground: {
    opacity: 0.5,
    backgroundColor: `${brand.main.water}80`,
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  cursorGrab: {
    // @ts-ignore
    cursor: 'grab',
  },
  cursorGrabbing: {
    // @ts-ignore
    cursor: 'grabbing',
  },
  cursorPointer: {
    cursor: 'pointer',
  },
  editIcon: {
    width: 36,
    height: 36,
    padding: 9,
    backgroundColor: neutrals.white,
    borderRadius: 100,
  },
  dragIcon: {
    width: 25,
    height: 25,
  },
  selectionContainerItem: {
    flexGrow: 1,
    flexShrink: 2,
    flexBasis: 0,
  },
});
